import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponseModel } from '../shared/models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class ExperiencesService {

  constructor(private http: HttpClient) { }
  addExperience(body) {
    return this.http.post<ApiResponseModel>('api/experience', body);
  }

  getSingleExperienceById(experienceId) {
    return this.http.get<ApiResponseModel>('api/experience/' + experienceId);
  }
  getAllLocalExperience() {
    return this.http.get<ApiResponseModel>('api/local-experience');
  }

  getAllOnlineExperience() {
    return this.http.get<ApiResponseModel>('api/online-experience');
  }

  getAllExperience() {
    return this.http.get<ApiResponseModel>('api/experience');
  }

  getAllExperienceTypes() {
    return this.http.get<ApiResponseModel>('api/experience/types');
  }

  updateExperience(body, experienceID) {
    return this.http.put<ApiResponseModel>(
      'api/experience/' + experienceID,
      body
    );
  }
  updateExperiencePicture(body, experienceID) {
    return this.http.put<ApiResponseModel>(
      'api/experience/updatePicture/' + experienceID,
      body
    );
  }
  getAvailablityExperience(id) {
    return this.http.get<ApiResponseModel>('api/availability/experience/' + id);
  }
  insertAvailablityLocal(body, id) {
    return this.http.post<ApiResponseModel>(
      'api/availability/local/' + id,
      body
    );
  }
  getAvailablityLocal(id) {
    return this.http.get<ApiResponseModel>('api/availability/local/' + id);
  }
  patchAvailabilty(body, id) {
    return this.http.patch<ApiResponseModel>(
      'api/availability/local/' + id,
      body
    );
  }
  deleteAssignedLocal(id) {
    return this.http.delete<ApiResponseModel>('api/experience/' + id + '/local');
  }
  insertAvailablityExperience(body, id) {
    return this.http.post<ApiResponseModel>(
      'api/availability/experience/' + id,
      body
    );
  }

  addOnlineExperience(body) {
    return this.http.post<ApiResponseModel>('api/online-experience', body);
  }

  updateOnlineExperience(id, body) {
    return this.http.put<ApiResponseModel>('api/online-experience/' + id, body);
  }
}
